import React, { useState, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import api from "../api";
import { theme } from "../theme";

const logo = "/metria-logo.svg";

const ResetarSenha = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get("token") || "", [params]);

  const [senha, setSenha] = useState("");
  const [senha2, setSenha2] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <img src={logo} alt="Metria" style={styles.logo} />
          <h2 style={styles.title}>Link invalido</h2>
          <p style={styles.desc}>
            Esta URL nao contem um token de redefinicao. Solicite um novo link.
          </p>
          <Link to="/esqueci-senha" style={{ ...styles.link, display: 'block', marginTop: 20, textAlign: 'center' }}>
            Pedir novo link
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (senha.length < 8) {
      setError("A senha deve ter pelo menos 8 caracteres.");
      return;
    }
    if (senha !== senha2) {
      setError("As senhas nao conferem.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, senha });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 2500);
    } catch (err) {
      const msg = err.response?.data?.erro;
      if (err.response?.status === 401) {
        setError("Link expirado ou invalido. Solicite um novo.");
      } else {
        setError(msg || "Falha ao redefinir. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={logo} alt="Metria" style={styles.logo} />
        <h2 style={styles.title}>Crie uma nova senha</h2>

        {done ? (
          <>
            <p style={{ ...styles.desc, color: '#1E7A3D' }}>
              Senha alterada com sucesso! Redirecionando para o login...
            </p>
          </>
        ) : (
          <>
            <p style={styles.desc}>
              Escolha uma senha com pelo menos 8 caracteres.
            </p>
            <form onSubmit={handleSubmit} style={{ marginTop: 24 }}>
              <div style={styles.inputWrap}>
                <FaLock style={styles.inputIcon} />
                <input
                  type={showPass ? 'text' : 'password'}
                  required minLength={8}
                  placeholder="Nova senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  style={styles.input}
                  autoFocus
                />
                <button type="button" onClick={() => setShowPass(!showPass)} style={styles.eyeBtn} tabIndex={-1}>
                  {showPass ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <div style={{ ...styles.inputWrap, marginTop: 10 }}>
                <FaLock style={styles.inputIcon} />
                <input
                  type={showPass ? 'text' : 'password'}
                  required minLength={8}
                  placeholder="Confirme a nova senha"
                  value={senha2}
                  onChange={(e) => setSenha2(e.target.value)}
                  style={styles.input}
                />
              </div>
              {error && <div style={styles.error}>{error}</div>}
              <button
                type="submit"
                disabled={loading}
                style={{ ...styles.btnPrimary, opacity: loading ? 0.6 : 1, marginTop: 16 }}
              >
                {loading ? "Salvando..." : "Salvar nova senha"}
              </button>
            </form>
            <p style={{ ...styles.desc, marginTop: 20, fontSize: 13, textAlign: 'center' }}>
              <Link to="/login" style={styles.link}>Voltar para o login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: theme.colors.bg, padding: 16,
  },
  card: {
    background: '#fff', padding: 32, borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
    maxWidth: 420, width: '100%',
  },
  logo: { display: 'block', margin: '0 auto 20px', height: 48 },
  title: {
    margin: '0 0 8px', fontSize: 22, fontWeight: 700,
    color: theme.colors.text, textAlign: 'center',
  },
  desc: {
    margin: 0, fontSize: 14, lineHeight: 1.6,
    color: theme.colors.textSecondary, textAlign: 'center',
  },
  inputWrap: { position: 'relative' },
  inputIcon: {
    position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
    color: theme.colors.textMuted, fontSize: 14,
  },
  eyeBtn: {
    position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
    background: 'transparent', border: 'none', cursor: 'pointer',
    color: theme.colors.textMuted, padding: 4,
  },
  input: {
    width: '100%', padding: '12px 40px 12px 40px',
    borderRadius: 10, border: `1px solid ${theme.colors.border}`,
    fontSize: 14, outline: 'none',
  },
  btnPrimary: {
    width: '100%', padding: '12px 16px', borderRadius: 10,
    border: 'none', background: theme.colors.primary, color: '#fff',
    fontWeight: 600, fontSize: 15, cursor: 'pointer',
  },
  link: {
    color: theme.colors.primary, textDecoration: 'none', fontWeight: 600,
  },
  error: {
    background: theme.colors.dangerLight || '#FEE',
    color: theme.colors.danger || '#B91C1C',
    padding: '10px 12px', borderRadius: 8,
    fontSize: 13, marginTop: 12,
  },
};

export default ResetarSenha;
